<template>
  <div class="container mx-auto my-10 p-4">
    <div class="w-full flex place-content-center">
      <div class="w-1/2 p-4 text-center">
        <div class="card-header p-4">
          <h2
            v-if="syndromeQuestionnaires"
            v-html="language == 'en' ? currentQuestionnaireTitle.title : currentQuestionnaireTitle.title_zh"
          ></h2>
        </div>

        <div
          class="flex flex-wrap bg-white rounded-md p-4"
          v-if="currentSection && !showEndMessage"
        >
          <RangeSlider
            v-if="!currentSection.is_textbox"
            :options="currentSection.option_set.options"
            :title="language == 'en' ? currentSection.title : currentSection.title_zh"
            v-model="currentSectionResult"
          />

          <TextInput
            v-if="currentSection.is_textbox"
            type="textarea"
            class="w-full"
            :label="language == 'en' ? currentSection.title : currentSection.title_zh"
            name="height"
            id="height"
            v-model="currentSectionResult"
          />
        </div>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="showEndMessage">
          <h2
            id="end-title"
            v-if="language=='en'"
          >Assessment Submitted. You may view or edit any part of the Assessment via the Dashboard</h2>
          <h2 id="end-title" v-else>评估已提交。您可以在主页浏览或编辑评估的任何部分</h2>
        </div>

        <Button
          class="w-full"
          v-if="showNextSectionButton"
          type="submit"
          id="next-section"
          :label="language == 'en' ? 'Continue' : '继续'"
          @click="nextSection"
        />
        <Button
          class="w-full"
          v-if="showNextQuestionnaireButton"
          type="submit"
          id="next-questionnaire"
          :label="language == 'en' ? 'Next Questionnaire' : '下一个问卷' "
          @click="nextQuestionnaire"
        />
        <Button
          class="w-full"
          v-if="showSubmitButton && !showEndMessage"
          type="submit"
          id="submit-questionnaire"
          :label="language == 'en' ? 'Submit' : '提交'"
          @click="endMessage"
        />

        <Button
          class="w-full"
          v-if="showEndMessage"
          type="submit"
          id="goto-dashboard"
          :label="language == 'en' ? 'Go to Dashboard' : '返回主页'"
          @click="gotoDashboard"
        />

        <p v-if="showError" class="text-red-500 text-right">Error. Must enter a value.</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#end-title {
  margin-top: 0;
  font-weight: 400;
  text-align: center;
  color: #88ad3f;
  margin-bottom: 20px;
  font-size: 1.5rem;
  line-height: 2rem;
}

@media screen and (max-width: 767px) {
  .w-1\/2 {
    width: 100%;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import Question from "./partials/Question";
import RadioSet from "./forms/RadioSet";
import Statement from "./partials/Statement";
import TextInput from "./forms/TextInput";
import RangeSlider from "./forms/RangeSlider";

export default {
  components: {
    Question,
    Statement,
    RadioSet,
    TextInput,
    RangeSlider
  },
  props: ["questionnaireSlug"],
  data() {
    return {
      assessment: this.$store.getters.assessment,
      currentSectionResult: null,
      showError: false,
      showEndMessage: false
    };
  },
  computed: {
    ...mapGetters({
      questionnaire: "questionnaire",
      syndromeQuestionnaires: "syndromeQuestionnaires",
      currentQuestionnaireTitle: "currentQuestionnaireTitle",
      currentSyndromeQuestionnaire: "currentSyndromeQuestionnaire", // deleteMe
      currentSection: "currentSection",
      showNextSectionButton: "showNextSectionButton",
      showNextQuestionnaireButton: "showNextQuestionnaireButton",
      showSubmitButton: "showSubmitButton",
      language: "clientLanguage"
    })
  },
  watch: {
    currentSection: {
      handler: function(val) {
        if (val != null) {
          this.currentSectionResult = val.result;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.loadQuestionnaire(this.questionnaireSlug);
  },
  methods: {
    loadQuestionnaire(slug) {
      this.$store
        .dispatch("fetchQuestionnaire", slug)
        .then(response => {
          console.warn("OK!");
          this.$store.dispatch("createSyndromeQuestionnaires", this.assessment);
        })
        .catch(error => {
          console.error(error);
        });
    },
    async storeResult(val) {
      this.showError = false;
      if (val == null) {
        this.showError = true;
        return;
      }

      let data = {};
      data.result = val;
      data.assessmentID = this.assessment.id;

      // console.log("storeResult()", data);
      await this.$store.dispatch("storeSyndromeQuestionnaireResult", data);
    },
    async nextSection() {
      await this.storeResult(this.currentSectionResult);
      if (!this.showError) {
        await this.$store.dispatch("incrementCurrentSection");
      }
    },
    async nextQuestionnaire() {
      await this.storeResult(this.currentSectionResult);
      if (!this.showError) {
        await this.$store.dispatch("incrementCurrentSyndromeQuestionnaire");
      }
    },
    async endMessage() {
      await this.storeResult(this.currentSectionResult);
      this.showEndMessage = true;
    },
    gotoDashboard() {
      window.location.href = "/dashboard";
    }
  }
};
</script>
